// extracted by mini-css-extract-plugin
export default {"cta":"dF-z","disabled":"eF-z"};